import React from 'react';
import Select from 'react-select';
import FormControl from 'react-bootstrap/FormControl';
import DateTimePicker from 'react-datetime-picker';

import FieldCity from '../../common/FieldCity';
import FieldState from '../../common/FieldState';
import FieldCountry from '../../common/FieldCountry';
import FieldController from '../../../controller/FieldController';
import Filter from '../../../components/filter/FilterPannel';
import Const from '../../../util/Constants';
import Util from '../../../util/Util';
import Display from '../../../util/Display';

class MassUpdate extends React.Component {

  constructor(props) {
    super(props);
    this.model = props.model;
    const fields = FieldController.getFilterFields(this.model.fields);
    this.fieldList = [];
    for(let i = 0; i < fields.length; i++) {
      if(!fields[i].editable) continue;
      if(fields[i].fieldKey === 'created_by' || fields[i].fieldKey === 'updated_by'
        || fields[i].fieldKey === 'created_date' || fields[i].fieldKey === 'updated_date'
        || fields[i].fieldKey.includes(Const.Address)) continue;
      this.fieldList.push({ id: fields[i].id, value: fields[i].fieldKey,
        type: fields[i].field_type, label: fields[i].label_name });
    }
    const modelUpdates = this.getUpdates(props.value);
    props.onUpdateChanged(modelUpdates);
    this.state = { updates: modelUpdates };
  }

  UNSAFE_componentWillReceiveProps(props) {
    const modelUpdates = this.getUpdates(props.value);
    this.setState({ ...this.state, updates: modelUpdates });
  }

  getUpdates = value => value.map(value => {
    const field = this.fieldList.find(field => field.value === value.field);
    if(field === undefined) return { ...this.value };
    const fOpt = this.getOptionField(field.type);
    const options = this.getOptions(fOpt, field.value, field.type, value.value);
    return { field, value: value.value, ...fOpt, ...options };
  });

  getOptionField = type => {
    const isText = FieldController.showTextFilter(type, Filter.Equals);
    const isDate = type === Const.Date;
    const isDateTime = type === Const.DateTime;
    const isNumber = type === Const.Decimal || type === Const.Number;
    const isFrom = FieldController.showDateFrom(type, Filter.Equals);
    const isTo = FieldController.showDateTo(type, Filter.Equals);
    const isCity = FieldController.showCity(type, Filter.Equals);
    const isState = FieldController.showState(type, Filter.Equals);
    const isCountry = FieldController.showCountry(type, Filter.Equals);
    const isSelect = FieldController.showSelect(type, Filter.Equals);
    const isComplete = FieldController.showComplete(type, Filter.Equals);
    return { isText, isFrom, isTo, isCity, isState, isComplete, isCountry, isSelect, isDate, isDateTime, isNumber };
  }

  getOptions = (fOpt, field, type, value) => {
    if(!value) value = '';
    let select = '', options = [], from = null, to = null;
    let isMulti = type.includes('multiselect');
    if(fOpt.isCity) {
      options = FieldController.getOptions({ field_type: Const.City });
    } else if(fOpt.isState) {
      options = FieldController.getOptions({ field_type: Const.State });
    } else if(fOpt.isCountry) {
      options = FieldController.getOptions({ field_type: Const.Country });
    } else if(fOpt.isSelect) {
      options = FieldController.getOptions(this.props.model.fields[field]);
    } else if(fOpt.isFrom || fOpt.isTo) {
      if(value.value) {
        const dates = value.value.split(Const.Opt);
        from = Util.serverStringDateTimeToDate(dates[0]);
        to = Util.serverStringDateTimeToDate(dates[1]);
      } else { from = null; to = null; }
    }
    select = isMulti ? options.filter(option => value.includes(`~${option.value}~`))
        : options.find(option => parseInt(value) === option.value);
    return { select, options, from, to};
  }

  add = () => this.setState({ ...this.state, updates:[ ...this.state.updates, { ...this.value }]});
  delete = index => {
    let updates = [ ...this.state.updates ];
    updates = updates.filter((_, i) => i !== index);
    this.setState({ ...this.state, updates: [ ...updates ] });
  }
  fieldChange = (i, field) => {
    const updates = [ ...this.state.updates ];
    if(field) {
      const fOpt = this.getOptionField(field.type);
      const options = this.getOptions(fOpt, field.value, updates[i].value ? updates[i].value : '');
      updates[i] = { field: field, ...fOpt, ...options }
    } else updates[i] = { field: field };
    this.props.onUpdateChanged(updates);
    this.setState({ ...this.state, updates: [ ...updates ] });
  }
  onSelect = (i, select) => {
    const value = select === null ? '' : Array.isArray(select) ? 
    `~${select.map(val => val.value).join('~')}~` : `${select.value}`;
    const updates = [ ...this.state.updates ];
    updates[i] = { ...updates[i], select: select, value };
    this.props.onUpdateChanged(updates);
    this.setState({ ...this.state, updates: [ ...updates ] });
  }
  onDateChange = (i, date) => {
    const updates = [ ...this.state.updates ];
    updates[i].to = date;
    if(date) {
      date.setHours(9);
      date.setMinutes(0);
      date.setSeconds(0);
      updates[i].value = Util.dateToServerDateTime(date);
    } else {
      updates[i].value = '';
    }
    updates[i].value = date ? Util.dateToServerDateTime(date) : '';
    this.props.onUpdateChanged(updates);
    this.setState({ ...this.state, updates: [ ...updates ] });
  }
  onTextChanged = (i, value) => {
    const updates = [ ...this.state.updates ];
    updates[i].value = value;
    this.props.onUpdateChanged(updates);
    this.setState({ ...this.state, updates: [ ...updates ] });
  }

  render() {
    return this.state.updates.map((filter, i) =>
      <div key={`condition_${i}`}className="col-md-12 condition-select-div">
        <div className="condition-select">
          <Select value={filter.field} className="mr-sm-2"
            onChange={ selected => this.fieldChange(i, selected) }
            options={this.fieldList} isSearchable={true} isClearable={true} />
        </div>
        <div className="condition-select value-float">
          { filter.isText ?
              <FormControl type="text" placeholder="Value" value={filter.value}
                onChange={ event => this.onTextChanged(i, event.target.value) } />
            : null
          }
          { filter.isDate ?
            <DateTimePicker value={filter.to} format="dd-MM-y" 
              onChange={ date => this.onDateChange(i, date)} />
            : null
          }
          { filter.isDateTime ?
            <DateTimePicker value={filter.to} format="dd-MM-y h:mm a" 
              onChange={ date => this.onDateChange(i, date)} />
            : null
          }
          { filter.isNumber ?
            <FormControl type="number" placeholder="Value" value={filter.value}
              onChange={ event => this.onTextChanged(i, event.target.value) } />
            : null
          }
          { filter.isSelect ?
            <Select value={filter.select} options={filter.options}
              onChange={ selected => this.onSelect(i, selected) } isSearchable={true}
              isClearable={true} isMulti={filter.field.type.includes('multiselect')} />
            : null
          }
          { filter.isComplete ?
            <Select value={filter.select} options={filter.options}
              onChange={ selected => this.onSelect(i, selected) } isSearchable={true}
              isClearable={true} isMulti={filter.field.type.includes('multiselect')} />
            : null
          }
          { filter.isCity ?
              <FieldCity defaultValue={filter.select} isMulti={false}
                onCitySelected={ selected => this.onSelect(i, selected) } />
            : null
          }
          { filter.isState ? 
              <FieldState defaultValue={filter.select} isMulti={false}
                onStateSelected={ selected => this.onSelect(i, selected) } /> 
            : null
          }
          { filter.isCountry ? 
              <FieldCountry defaultValue={filter.select} isMulti={false}
                onSelected={ selected => this.onSelect(i, selected) } />
            : null
          }

          { Display.MultiAction(i, this.add, this.delete ) }
        </div>
      </div>
    );
  }
}
export default MassUpdate;